module.exports = __webpack_public_path__ + "static/media/bgEditExercises.27b66e0d.jpg";